<template>
  <div :class="button?'variants__items':'stock__sorting'">
    <div :class="button?'variants__item':'stock__sorting-item'">
      <span class="ui-selectmenu-button ui-button compact-select"
            :class="{'is-disabled': !canOpenList('mark')}"
            @click.stop="toggleList('mark')"
            select-item="mark">
        <span class="ui-selectmenu-icon ui-icon"></span>
        <span class="ui-selectmenu-text uk-text-truncate">{{select_mark==null?'Марка автомобиля':select_mark.title}}</span>
          <select-item
              id="mark"
              state="Марка автомобиля"
              :open="list_open === 'mark'"
              :data="marks"
              :queryItem="init_mark"
              @selected="select_mark = $event.item, init_mark = null"
              @open="onListOpen"
          />
      </span>
    </div>
    <div :class="button?'variants__item':'stock__sorting-item'">
      <span class="ui-selectmenu-button ui-button compact-select"
            :class="{'is-disabled': !canOpenList('model')}"
            @click.stop="toggleList('model')"
            select-item="model">
        <span class="ui-selectmenu-icon ui-icon"></span>
        <span class="ui-selectmenu-text uk-text-truncate">{{select_model==null?'Модель автомобиля':select_model.title}}</span>
          <select-item
              id="model"
              state="Модель автомобиля"
              :open="list_open === 'model'"
              :data="models"
              :queryItem="init_model"
              @selected="select_model = $event.item, init_model = null"
              @open="onListOpen"
          />
      </span>
    </div>
    <div :class="button?'variants__item':'stock__sorting-item'">
      <span class="ui-selectmenu-button ui-button compact-select"
            :class="{'is-disabled': !canOpenList('set')}"
            @click.stop="toggleList('set')"
            select-item="set">
        <span class="ui-selectmenu-icon ui-icon"></span>
        <span class="ui-selectmenu-text uk-text-truncate">{{select_set==null?'Комплектация':select_set.title}}</span>
          <select-item
              id="set"
              state="Комплектация"
              :open="list_open === 'set'"
              :data="set"
              :queryItem="init_set"
              @selected="select_set = $event.item, init_set = null"
              @open="onListOpen"
          />
      </span>
    </div>
    <div class="variants__item" v-if="button">
      <button
          type="button"
          class="green"
          @click="testSelection"
      >
        Подобрать товар
      </button>
    </div>

    <div
        v-if="button"
        :class="{'select-notice--show' : errorMessage}"
        class="select-notice"
    >
      <span v-html="errorMessage"></span>
    </div>
  </div>
</template>

<script>
import SelectItem from './SelectItem'
import { fetchSelectionOptions } from '../api/adminBrands'

export default {
  name: 'widget-select',
  components: {
    SelectItem
  },
  props: {
    button: {
      object: Boolean,
      default: true,
    }
  },
  computed: {
    hasMarks() {
      return Array.isArray(this.marks) && this.marks.length > 0
    },
    hasModels() {
      return !!this.select_mark && Array.isArray(this.models) && this.models.length > 0
    },
    hasSets() {
      return !!this.select_model && Array.isArray(this.set) && this.set.length > 0
    },
    buildQuery() {
      let query = ''
      if (this.select_mark) query += `?mark=${encodeURIComponent(this.select_mark.title)}`
      if (this.select_model) query += `&model=${encodeURIComponent(this.select_model.title)}`
      if (this.select_set) query += `&set=${encodeURIComponent(this.select_set.id)}`
      return query
    },
    selectionPayload() {
      if (!this.select_mark || !this.select_model || !this.select_set) return null
      return {
        make: this.select_mark.title,
        model: this.select_model.title,
        body: this.select_set.body || null,
        engine: this.select_set.engine || null,
        volume: this.select_set.volume || null,
        car_info_id: this.select_set.id,
        set_title: this.select_set.title,
      }
    },
  },
  data() {
    return {
      list_open: false,
      select_model: null,
      select_mark: null,
      select_set: null,
      init_model: null,
      init_mark: null,
      init_set: null,
      models: null,
      marks: null,
      set: null,
      errorMessage: null,
    }
  },
  watch: {
    select_mark: function() {
      this.list_open = false
      this.select_model = null
      this.select_set = null
      this.models = null
      this.set = null
      if (this.errorMessage) this.testSelection(false)
      this.getInitDataModels()
    },
    select_model: function() {
      this.list_open = false
      this.select_set = null
      this.set = null
      if (this.errorMessage) this.testSelection(false)
      this.getInitDataModifics()
    },
    select_set: function(value) {
      if (!this.button && value && this.selectionPayload) {
        this.$emit('selection', this.selectionPayload)
      }
      if (this.errorMessage) this.testSelection(false)
    },
  },
  methods: {
    canOpenList(name) {
      if (name === 'mark') return this.hasMarks
      if (name === 'model') return this.hasModels
      if (name === 'set') return this.hasSets
      return false
    },
    toggleList(name) {
      if (this.list_open === name) {
        this.list_open = false
        return
      }
      if (!this.canOpenList(name)) {
        this.list_open = false
        return
      }
      this.list_open = name
    },
    onListOpen(event) {
      if (!event || !event.enabled) {
        this.list_open = false
      }
    },
    testSelection(ref = true) {
      this.errorMessage = null
      let messages = []

      if (!this.select_mark) messages.push('<b>марка авто</b>')
      if (!this.select_model) messages.push('<b>модель авто</b>')
      if (!this.select_set) messages.push('<b>комплектация авто</b>')

      if (messages.length) {
        this.errorMessage = 'Не выбрана ' + messages.join(', ');
        return false
      }

      if (ref) {
        this.$router.push(`/choose${this.buildQuery}`)
      }
    },
    fetchQuery() {
      if (this.$route.query.mark) this.init_mark = this.$route.query.mark
      if (this.$route.query.model) this.init_model = this.$route.query.model
      if (this.$route.query.set) this.init_set = this.$route.query.set
    },
    async getInitDataMarks() {
      try {
        this.marks = await fetchSelectionOptions('make')
      } catch (e) {
        this.marks = []
      }
    },
    async getInitDataModels() {
      if (!this.select_mark) return
      try {
        this.models = await fetchSelectionOptions('model', {
          make: this.select_mark.title,
        })
      } catch (e) {
        this.models = []
      }
    },
    async getInitDataModifics() {
      if (!this.select_model || !this.select_mark) return
      try {
        this.set = await fetchSelectionOptions('modific', {
          make: this.select_mark.title,
          model: this.select_model.title,
        })
      } catch (e) {
        this.set = []
      }
    },
  },
  beforeMount() {
    this.getInitDataMarks()
    this.fetchQuery()
  },
}
</script>
